/*
 * @Author: Luz Liu luz.liu@zoom.us
 * @Date: 2022-07-20 10:51:57
 * @LastEditors: Luz Liu luz.liu@zoom.us
 * @LastEditTime: 2022-07-20 11:06:36
 * @FilePath: \async-component-ui\packages\components\upload\index.js
 * @Description: ~
 */
import AsParse from './parse'
AsParse.install = (Vue) => {
  Vue.component(AsParse.name, AsParse)
}

export default AsParse
